import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, startWith, tap } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class EmbeddedService {
	public isEmbedded = false;
	constructor(private router: Router) {}

	public getLeafRoute(route: ActivatedRoute): ActivatedRoute {
		while (route.firstChild) {
			route = route.firstChild;
		}
		return route;
	}

	public getIsEmbedded() {
		return this.router.events.pipe(
			filter((event) => event === null || event instanceof NavigationEnd),
			map(() => this.getLeafRoute(this.router.routerState.root)),
			map((route) => route.snapshot.data["embedded"]),
			map((res) => !!res),
		);
	}
}
